module.exports = __webpack_public_path__ + "static/ogp-qa-1c9559a31011ea030f740f6bd80e3a1b.png";